/**
 * External dependencies
 */
import React, { useState, useEffect, useCallback } from 'react';
import { map, noop } from 'lodash';
import update from 'immutability-helper';

/**
 * Internal dependencies
 */
import Item from './item';

/**
 * Style dependencies
 */
import './styles.scss';

const MoveableStack = ({ items, onChange = noop }) => {
	const [draggableItems, setDraggableItems] = useState(items);

	useEffect(() => {
		setDraggableItems(items);
	}, [items.length]);

	const moveItem = useCallback(
		(dragIndex, hoverIndex) => {
			const dragItem = draggableItems[dragIndex];
			let updated = update(draggableItems, {
				$splice: [
					[dragIndex, 1],
					[hoverIndex, 0, dragItem],
				],
			});
			setDraggableItems(updated);
			onChange(updated);
		},
		[draggableItems],
	);

	const renderItem = (item, index) => {
		return <Item {...item} key={item.id} index={index} id={item.id} moveItem={moveItem} />;
	};

	return (
		<div className='moveable-stack__wrapper'>{map(draggableItems, (item, index) => renderItem(item, index))}</div>
	);
};

export default MoveableStack;
